import React from 'react';

// Het merkbeeld boven de inlog-, MFA-, reset- en privacyschermen.
//
// Twee regels zitten hierin:
//  1. COMPLIANCE (zie CLAUDE.md) — het platformlogo hoort ENKEL op het hoofddomein
//     (en in dev). Op een merkdomein tonen we liever even niets dan het verkeerde
//     merk, ook niet één tekening lang.
//  2. GEEN MERKWISSEL — de huisstijl komt uit de database en dus over het net; tot
//     ze er is toont dit scherm zijn merknaam (die kennen we meteen uit
//     BRAND_CONFIG) en verschijnt het logo zodra het binnen of onthouden is.
//
// `brand` komt uit AuthenticatedApp: { logo, name, etLogoToegestaan }.
export default function MerkLogo({ brand, className = 'h-16 mx-auto mb-4 object-contain' }) {
  const logo = brand?.logo || (brand?.etLogoToegestaan ? '/logo.png' : null);
  if (!logo) return null;
  return <img src={logo} alt={brand?.name || 'Partner Portal'} className={className} />;
}
